/** Strips common assembly/module suffixes and normalizes for comparison. */
export const normalizeAssemblyName = (assemblyName: string | undefined): string => {
  const trimmed = assemblyName?.trim() ?? ''
  if (!trimmed) return ''

  return trimmed.replace(/-\d+\.\d+(\.\d+)*(-[\w.]+)?\.jar$/i, '').replace(/\.(jar|dll|exe)$/i, '')
}
